import { MasterData } from '../types/types'

export const transformMasterData = (masterData: MasterData[]) =>
  masterData.map((data) => ({ id: data.id, label: data.name }))
